import type { LucideIcon } from 'lucide-react';
import { PageHeader } from '@/components/layout/PageHeader';
import { ScreenModeBadge } from './ScreenModeBadge';

interface MasterPageHeaderProps {
  /** The screen's icon, e.g. lucide's `Calendar`. Rendered at a fixed size and colour. */
  icon: LucideIcon;
  title: string;
  subtitle?: string;
  screen: { isNew: boolean; isEdit: boolean; isView: boolean };
}

/**
 * The title strip at the top of a master screen: the shared PageHeader, plus the mode chip.
 *
 * Eight pages carried this markup. Seven agreed on it; the cost centre screen had drifted to a
 * smaller icon, a tighter bar and an indigo tint, so two master screens opened differently for no
 * reason a user could name. The geometry now lives in PageHeader, which the setup screens share.
 *
 * The chip belongs here and only here. Four setup screens had it inside their toggle component
 * instead, which put a NEW/EDIT/VIEW pill beside every switch on the form and none at the top of
 * the screen. Rendering it as part of the header makes that mistake unavailable.
 */
export const MasterPageHeader = ({ icon, title, subtitle, screen }: MasterPageHeaderProps) => (
  <PageHeader
    testId="master-header"
    icon={icon}
    title={title}
    subtitle={subtitle}
    actions={<ScreenModeBadge isNew={screen.isNew} isEdit={screen.isEdit} isView={screen.isView} />}
  />
);
